<section class="team-members-section" id="team-members">
  <!-- team members header section -->
  <div class="team-members-section__header">
    <pwj-sections-title class="header-title">
      <span class="header-title__label"
        >{{ 'global.team_members' | translate }}
      </span>
      <!-- business title -->
      <!-- <span class="header-title__company-name">{{
        membersData()?.title | translateData
      }}</span> -->
    </pwj-sections-title>
  </div>
  <!-- ceo section -->
  <div
    class="team-members-section__ceo"
    [ngClass]="{ '!mb-10': membersData()?.people?.length === 0 }">
    <!-- team members ceo left section -->
    <div class="ceo-section__profile-image-container">
      <img
        class="user-image"
        [ngSrc]="
          membersData()?.owner?.profile_image?.cropped_url?.toLowerCase() ||
            membersData()?.owner?.profile_image?.url
            | imageSource: false : 'sm' : 'assets/images/no-profile-image.png'
        "
        alt=""
        height="200"
        width="200" />
    </div>
    <!-- team members ceo info section -->
    <div class="ceo-section__info">
      <div class="ceo-section__info-top">
        <div>
          <p class="ceo-section__info-name">
            {{ membersData()?.owner?.first_name }}
            {{ membersData()?.owner?.last_name }}
          </p>
          <p class="ceo-section__info-job">
            {{ membersData()?.title | translateData }}
          </p>
          <p class="ceo-section__info-number">
            {{ membersData()?.owner?.mobile?.prefix }}
            {{ membersData()?.owner?.mobile?.mobile_number }}
          </p>
        </div>
        @if ((membersData()?.links?.length || 0) > 0) {
          <ul class="ceo-section__info-box">
            @for (link of membersData()?.links; track link?.type) {
              @if (socialMediaConstant?.[link.type]) {
                <li>
                  <a
                    [href]="socialMediaConstant[link.type].prefixUrl + link.url"
                    target="_blank">
                    <img
                      class="ceo-section__social-icon"
                      [ngSrc]="socialMediaConstant[link.type].icon"
                      width="26"
                      height="26"
                      [alt]="link.url" />
                  </a>
                </li>
              }
            }
          </ul>
        }
      </div>
      <p class="ceo-section__description">
        {{ membersData()?.ceo_description | translateData }}
      </p>
    </div>
  </div>
  <!-- team members list -->
  @if ((membersData()?.people?.length || 0) > 0) {
    <div class="team-members-section__members">
      <ul class="members-list">
        @for (member of membersData()?.people; track $index) {
          <pwj-team-member-card [cardData]="member"></pwj-team-member-card>
        }
      </ul>
    </div>
  }
</section>
